import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--gap);
	gap: var(--gap);
	flex: 1;
	min-height: 0;
	max-height: calc(var(--max-height) - 5vh);
	border-bottom: var(--px-1) solid var(--neutrals-200);
	& > span {
		flex-shrink: 0;
	}
`;
